/**
 * The three places a pin can sit.
 *
 * MIRRORS PHP: `render.php` holds the same three values and falls back to
 * `top-left` for anything else. Two runtimes, no shared module — the editor
 * needs it as an ES module and the renderer needs it before any JS runs.
 * Change one, change the other. Same posture as `Notice/notice-types.js`.
 *
 * The clamp matters: only these values have positioning CSS behind them, so an
 * unrecognised one (hand-edited content, a value retired in a later version)
 * would leave the pin at its static position, overlapping the first inner
 * block. The server already guards against that; without the same guard here
 * the canvas would misrender precisely when the fallback fires.
 */

import { __ } from '@wordpress/i18n';

export const DEFAULT_PIN_POSITION = 'top-left';

export const PIN_POSITIONS = [
  { label: __('Top left', 'brandy-blocks'), value: 'top-left' },
  { label: __('Top centre', 'brandy-blocks'), value: 'top-center' },
  { label: __('Top right', 'brandy-blocks'), value: 'top-right' },
];

export const clampPinPosition = (value) =>
  PIN_POSITIONS.some((position) => position.value === value)
    ? value
    : DEFAULT_PIN_POSITION;
